import { useContext } from 'react'
import PropTypes from 'prop-types'

import { HeartIcon } from 'reactGarden/HeartIcon'

import WishlistProviderMethods from 'reactSite/Wishlist/provider'
import { WishlistContext } from 'reactSite/Wishlist/context'

import * as S from './styled'

const WishlistButton = ({ product }) => {
  const id = product.id
  const { onPressHeart, isOnWishlist } = useContext(WishlistContext)

  const isActive = isOnWishlist(id)

  const handleClick = () => onPressHeart({ id, product }, 'products')

  return (
    <S.Button
      onClick={handleClick}
      type="button"
      title="Adicionar a lista de favoritos"
    >
      <HeartIcon isActive={isActive} />
    </S.Button>
  )
}

const WishlistButtonWithProvider = ({
  productId,
  productName,
  productPriceIntergers,
  productPriceDecimals
}) => {
  const product = {
    id: productId,
    shortName: productName,
    price: {
      to: {
        integers: productPriceIntergers,
        decimals: productPriceDecimals
      }
    }
  }

  return (
    <WishlistProviderMethods>
      <WishlistButton product={product} />
    </WishlistProviderMethods>
  )
}

WishlistButton.propTypes = {
  id: PropTypes.number.isRequired
}

WishlistButtonWithProvider.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default WishlistButtonWithProvider
